export const data8_1_default = [{
    utility_item: 'Electricity 电能 (KWH 千瓦时)',//name
    cma_thisyear_consumption: 0,// Consumption 消耗量
    cma_thisyear_average: "",//Average Unit Price 平均单价
    cma_thisyear_cost: 0,//Cost 成本费用
    cma_lastyear_consumption: 0,//Consumption 消耗量
    cma_lastyear_average: "",//Average Unit Price 平均单价
    cma_lastyear_cost: 0,//Cost 成本费用
    cmv_comparison_consumption: "",//Consumption 消耗量
    cmv_comparison_consumption_percent: "",//% 百分比
    cmv_comparison_average: "",//Average Unit Price 平均单价
    cmv_comparison_average_percent: "",//% 百分比
    cmv_comparison_cost: "",//Cost 成本费用
    cmv_comparison_cost_percent: "",//% 百分比
    ytda_thisyear_consumption: 0,//Consumption 消耗量
    ytda_thisyear_average: "",//Average Unit Price 平均单价
    ytda_thisyear_cost: 0,//Cost 成本费用
    ytda_lastyear_consumption: 0,//Consumption 消耗量
    ytda_lastyear_average: "",//Average Unit Price 平均单价
    ytda_lastyear_cost: 0,//Cost 成本费用
    ytdv_comparison_consumption: "",//Consumption 消耗量
    ytdv_comparison_consumption_percent: "",//% 百分比
    ytdv_comparison_average: "",//Average Unit Price 平均单价
    ytdv_comparison_average_percent: "",//% 百分比
    ytdv_comparison_cost: "",//Cost 成本费用、 
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,
    squmareMeter: 0,
}, {
    utility_item: 'Water 水 (m³ 立方)',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,
    squmareMeter: 0,
}, {
    utility_item: 'Gas 燃气 (m³ 立方)',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,
    squmareMeter: 0,
}, {
    utility_item: 'Others 其他',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,
    squmareMeter: 0,
}];


export const data8_1_2 = [{
    utility_item: 'Electricity 电能 (KWH 千瓦时)',//name
    cma_thisyear_consumption: 0,// Consumption 消耗量
    cma_thisyear_average: "",//Average Unit Price 平均单价
    cma_thisyear_cost: 0,//Cost 成本费用
    cma_lastyear_consumption: 0,//Consumption 消耗量
    cma_lastyear_average: "",//Average Unit Price 平均单价
    cma_lastyear_cost: 0,//Cost 成本费用
    cmv_comparison_consumption: "",//Consumption 消耗量
    cmv_comparison_consumption_percent: "",//% 百分比
    cmv_comparison_average: "",//Average Unit Price 平均单价
    cmv_comparison_average_percent: "",//% 百分比
    cmv_comparison_cost: "",//Cost 成本费用
    cmv_comparison_cost_percent: "",//% 百分比

    ytda_thisyear_consumption: 0,//Consumption 消耗量
    ytda_thisyear_average: "",//Average Unit Price 平均单价
    ytda_thisyear_cost: 0,//Cost 成本费用
    ytda_lastyear_consumption: 0,//Consumption 消耗量
    ytda_lastyear_average: "",//Average Unit Price 平均单价
    ytda_lastyear_cost: 0,//Cost 成本费用
    ytdv_comparison_consumption: "",//Consumption 消耗量
    ytdv_comparison_consumption_percent: "",//% 百分比
    ytdv_comparison_average: "",//Average Unit Price 平均单价
    ytdv_comparison_average_percent: "",//% 百分比
    ytdv_comparison_cost: "",//Cost 成本费用
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}, {
    utility_item: 'Water 水 (m³ 立方)',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}, {
    utility_item: 'Rooms Occupied 出租客房间夜数 （与1.1中数据同步）',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}, {
    utility_item: 'Average electricity  consumption per guestroom <br/>每客房人均能源消耗量 （电能）(KWH 千瓦时)',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}, {
    utility_item: 'Average water consumption per guestroom   <br/>每客房人均能源消耗量 （水） (m³ 立方)',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}];


export const data8_1_3 = [{
    utility_item: 'Electricity 电能 (KWH 千瓦时)',//name
    cma_thisyear_consumption: 0,// Consumption 消耗量
    cma_thisyear_average: "",//Average Unit Price 平均单价
    cma_thisyear_cost: 0,//Cost 成本费用
    cma_lastyear_consumption: 0,//Consumption 消耗量
    cma_lastyear_average: "",//Average Unit Price 平均单价
    cma_lastyear_cost: 0,//Cost 成本费用
    cmv_comparison_consumption: "",//Consumption 消耗量
    cmv_comparison_consumption_percent: "",//% 百分比
    cmv_comparison_average: "",//Average Unit Price 平均单价
    cmv_comparison_average_percent: "",//% 百分比
    cmv_comparison_cost: "",//Cost 成本费用
    cmv_comparison_cost_percent: "",//% 百分比

    ytda_thisyear_consumption: 0,//Consumption 消耗量
    ytda_thisyear_average: "",//Average Unit Price 平均单价
    ytda_thisyear_cost: 0,//Cost 成本费用
    ytda_lastyear_consumption: 0,//Consumption 消耗量
    ytda_lastyear_average: "",//Average Unit Price 平均单价
    ytda_lastyear_cost: 0,//Cost 成本费用
    ytdv_comparison_consumption: "",//Consumption 消耗量
    ytdv_comparison_consumption_percent: "",//% 百分比
    ytdv_comparison_average: "",//Average Unit Price 平均单价
    ytdv_comparison_average_percent: "",//% 百分比
    ytdv_comparison_cost: "",//Cost 成本费用
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}, {
    utility_item: 'Water 水 (m³ 立方)',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}, {
    utility_item: 'Gas 燃气 (m³ 立方)',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}, {
    utility_item: 'Covers of Outlet -F&B ( same as 5.1.1) <br/>餐饮就餐人数 （与5.1.1 同步）',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}, {
    utility_item: 'Average electricity  consumption by kitchen <br/>厨房人均能源消耗量 （电能）(KWH 千瓦时)',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}, {
    utility_item: 'Average water  consumption by kitchen <br/> 厨房人均能源消耗量 （水） (m³ 立方)',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}, {
    utility_item: 'Average gas  consumption by kitchen <br/> 厨房人均能源消耗量 （燃气） (m³ 立方)',
    cma_thisyear_consumption: 0,
    cma_thisyear_average: "",
    cma_thisyear_cost: 0,
    cma_lastyear_consumption: 0,
    cma_lastyear_average: "",
    cma_lastyear_cost: 0,
    cmv_comparison_consumption: "",
    cmv_comparison_consumption_percent: "",
    cmv_comparison_average: "",
    cmv_comparison_average_percent: "",
    cmv_comparison_cost: "",
    cmv_comparison_cost_percent: "",
    ytda_thisyear_consumption: 0,
    ytda_thisyear_average: "",
    ytda_thisyear_cost: 0,
    ytda_lastyear_consumption: 0,
    ytda_lastyear_average: "",
    ytda_lastyear_cost: 0,
    ytdv_comparison_consumption: "",
    ytdv_comparison_consumption_percent: "",
    ytdv_comparison_average: "",
    ytdv_comparison_average_percent: "",
    ytdv_comparison_cost: "",
    ytdv_comparison_cost_percent: "",//Cost 成本费用百分比
    cma_lastyear_lastmonth_consumption: 0,
    cma_lastyear_lastmonth_average: 0,
    cma_lastyear_lastmonth_cost: 0,
    ytdv_lastmonth_comparison_consumption: 0,
    ytdv_lastmonth_comparison_consumption_percent: 0,
    ytdv_lastmonth_comparison_average: 0,
    ytdv_lastmonth_comparison_average_percent: 0,
    ytdv_lastmonth_comparison_cost: 0,
    ytdv_lastmonth_comparison_cost_percent: 0,

}];



export const data8_2_1 = [{
    name: "8.2.1 Maintenance Material cost 维修材料费用统计",
    year_now_actual: 0,
    year_last_actual: 0,
    lastYear_now_actual: 0,
    year_actual: 0,
    lastYear_actual: 0,
    lastYear_fee: 0,
    lastYear_percent: 0,
    year_fee: 0,
    year_percent: 0,
    last_fee: 0,
    last_percent: 0,
}, {
    name: "8.2.2  Maintenance/ Testing cost 保养/检测费用统计",
    year_now_actual: 0,
    year_last_actual: 0,
    lastYear_now_actual: 0,
    year_actual: 0,
    lastYear_actual: 0,
    lastYear_fee: 0,
    lastYear_percent: 0,
    year_fee: 0,
    year_percent: 0,
    last_fee: 0,
    last_percent: 0,
}]


// WEBPACK FOOTER //
// ./src/components/table/8.0/8-1/data.js